import { useEffect} from 'react';

export default function Gtm({title}) { 

useEffect(() => {
  window.dataLayer.push({
    event: 'pageview',
    pageTitle: title,
    pagePath: window.location.href,
  });
}, []);

}
